import React from "react";
import { LoginPage } from './../pages/login.page';
import { RazorpayAuthorizePage } from './../pages/razorpay-authorize.page';
import { HomePage } from "../pages/home.page";
import { BusCancelPage } from "../pages/bus-cancel.page";
import { NotificationPage } from "../pages/notification.page";
import { ViewTicketPage } from "../pages/view-ticket.page";
import { BrowserRouter as Router, Route , Switch} from 'react-router-dom';
import  PrivateRoute from "./private-route";
import { AppHeader} from './../components/app-header/app-header.component';
import { BookedTicketsReport } from './../pages/reports/booked-tickets.report';
import { SettlementReport } from './../pages/reports/settlement.report';
import { ChangePasswordPage } from'./../pages/change-password.page';
import { LoadingComponent } from './../components/loading-component/loading.component';
import { TripSheetReport } from './../pages/reports/trip-sheet.report';
import { SalesTicketReport } from './../pages/reports/sales-ticket.report';
import { SharedTripSalesReport } from './../pages/reports/shared-trip-sales.report';
import { MasterAgentSalesReport } from './../pages/reports/master-agent-sales.report';
import { MasterTripSheetReport } from './../pages/reports/master-trip-sheet.report';
import { TicketSearchReport } from './../pages/reports/ticket-search-report';
import { TicketSearchReportV2 } from './../pages/reports/ticket-search-report-v2';
import { RescheduledTicketReport } from './../pages/reports/rescheduled-ticket-report';
import { ViewPassengersInfoReport } from './../pages/reports/view-passengers-info.report';
import { PerformanceReport } from "./../pages/reports/performance.report";
import { BlockedSeatsReport } from './../pages/reports/blocket-seats.report';
import { TotalTransactionReport } from './../pages/reports/total-transaction.report';
import { CancelledTicketsReport } from './..//pages/reports/cancel-tickets.report';
import { AbandonedReport } from './..//pages/reports/abandoned.report';
import { WebSalesTicketReport } from './../pages/reports/web-ticket-sales.report';
import { WebTicketCancelReport } from './../pages/reports/web-ticket-cancel.report';
import { SmsReportComponent } from './../pages/reports/sms.report';
import { StaffPage } from './../pages/staff.page';
import { TicketsBookedAfterTripStartTime } from './../pages/reports/tickets-booked-after-start-time.report';
import { DeviceProvider } from './../components/device-provider/device-provider';
import { ActiveBookingsReport } from './../pages/reports/active-bookings.report';
import { RevenueReport } from "./../pages/reports/revenue.report";
import { AgentsUserPage } from './../pages/agents-user.page';
import { AgentLedgerPage } from './../pages/agent-ledger.page';
import { SystemInfoPage } from '../pages/admin/system-info.page';
import { 
    checkSearchPage,
    checkCancelPage,
    checkViewNotificationPage,
    checkBusCancellationPage,
    checkStaffPage,
    viewBookedTicketsReport,
    viewSettlementReport,
    viewMasterTripReport,
    viewPassengerInfoReport,
    viewSalesReport,
    viewSharedTripSalesReport,
    viewMasterAgentSalesReport,
    viewTicketSearchReport,
    viewTicketSearchReportOld,
    viewTripReport,
    blockedSeatsReport,
    viewPerformanceReport,
    viewTotalTransactionReport,
    cancelledSeatsReport,
    checkViewAbandonedReport,
    checkWebTicketSalesReport,
    checkWebTicketCancelReport,
    tripExpenseReport,
    viewTicketBookedAfterTripStartTime,
    viewSmsReport,
    checkAgentsTransactionPage,
    checkAgentLedgerPage,
    checkToViewSystemInfoPage,
    checkAgentsPage,
    viewDemandDataReport,
    tripCreate,
    checkToViewTripsPageOfAdmin,
    checkToViewBulkTripVehicleUpdatePage,
    checkToViewPopularRoutesPageAdmin,
    viewActiveBookings,
    viewServiceCountReport,
    viewOccupancyReport,
    viewBusServiceCollectionReport,
    checkToViewStandardStopsPage,
    checkToViewTripSheetPermissionPage,
    checkToViewSchedulesPageOfAdmin,
    viewRescheduledTicketReport,
    viewTicketSharingReport,
    viewCostSummaryReportReport,
    viewTransactionSummaryReportReport,
    viewRevenueReport,
    checkToViewCitiesPageAdmin,
    checkPrepaidOTAPage,
    viewPrePaidReport,
    viewTrackingSummaryReport,
    checkToViewUserActions,
    checkDashBoardPage,
    checkToViewOperatorConfig,
    checkToViewBusOperatorPage,
    checkToViewColourConfig,
    checkToViewOperatorWebsiteConfig,
    checkToViewExpenseConfig,
    checkToViewServiceAccessPage,
    checkToViewServiceSharingPage,
    checkToViewBookingPartnersPage,
    checkToViewTemporaryChangesPage,
    checkToViewVechicleManagementPageAdmin,
    checkToViewBusesPageAdmin,
    checkToViewOtaSearchPage,
    checkToViewAgentsPageOfAdmin,
    checkToViewCancellationPolicyPage,
    checkToViewTicketImportPage,
    viewDriverAttendanceReport,
    viewExpenseReport,
    viewStopAnalysisReport,
    checkToViewBookingConfig,
    checkToViewBillingConfig,
    checkToViewDiscountConfig,
    checkToSetSettlementOpeningBalance,
    checkToGenerateSettlementDraft,
    viewSettlementAdmin,
    viewOwnSettlement
   } from './../components/app-header/app.header.module';
import {Helmet} from "react-helmet";
import { Row, Tooltip } from 'antd';
import { AgentsPage } from "../pages/agents.page";
import { AgentTransactonsPage } from "../pages/agent-transactions.page";
import { DemandDataReport } from "../pages/reports/demand-data.report";
import { TripCreatePage } from './../pages/trip-create.page'
import { IncompleteTripPage } from "../pages/incomplete-trip.page";
import { TripCreateSuccessPage } from './../pages/trip-create-success.page';
import { ServiceCountReport } from "../pages/reports/service-count.report";
import { OccupancyReport } from "../pages/reports/occupancy.report";
import { BusServiceCollectionReport } from "../pages/reports/bus-service-collection.report";
import { StandardStopsPage } from "../pages/standard-stops.page";
import { CreateStandardStopsPage } from "../pages/create-standard-stop.page";
import { TripSheetPermissionPage } from "../pages/trip-sheet-permission.page";
import { SchedulePage } from "../pages/admin/schedule.page";
import { GstFilingReport } from "../pages/reports/gst-filing.reports";
import { RoutePriorityPage } from "../pages/admin/route-priority.page";
import { useSelector } from "react-redux";
import { userLoginSelector } from "../selector/user.selector";
import { TicketSharingReport } from "../pages/reports/ticket-sharing.report";
import { CostSummaryReport } from "../pages/reports/cost-summary.report";
import { TransactionSummaryReport } from "../pages/reports/transaction-summary.report";
import { DashboardPage } from "../pages/dash-board.page";
import { CitiesPage } from "../pages/admin/cities.page";
import { PrepaidOTAPage } from "../pages/prepaid-ota.page";
import { ManualTripPage } from "../pages/manual-trip.page";
import { AddressBookPage } from "../pages/address-book.page";
import { PrePaidTransactionsSummary } from "../pages/reports/pre-paid-transactions-summary.report";
import { TrackingSummaryReport } from "../pages/reports/tracking-data.report";
import { DriverAttendanceReport } from "../pages/reports/driver-attendance.report";
import { UserActionsPage } from "../pages/admin/user-actions.page";
import { DiscountConfigPage } from "../pages/admin/discount-config.page";
import { isValid } from "../utils/utilities";
import { OperatorConfigPage } from "../pages/admin/operator-config.page";
import { QbccConfigPage } from "../pages/admin/qbcc-config.page";
import { BusOperatorPage } from "../pages/admin/bus-operator.page";
import { OpeningBalanceSeedPage } from "../pages/settlements/opening-balance-seed.page";
import { SettlementsGeneratePage } from "../pages/settlements/settlements-generate.page";
import { SettlementsHistoryPage } from "../pages/settlements/settlements-history.page";
import { SettlementsRootPage } from "../pages/settlements/settlements-root.page";
import { SettlementsBillingPage } from "../pages/settlements/settlements-billing.page";
import { BookingConfigPage } from "../pages/admin/booking-config.page";
import { BillingConfigPage } from "../pages/admin/billing-config.page";
import { ExpenseConfigPage } from "../pages/admin/expense-config.page";
import { ColourConfigPage } from "../pages/admin/colour-config.page";
import { OperatorWebsitePageConfig } from "../pages/admin/operator-website-page-config.page";
import { ServiceAccessPage } from "../pages/service-access.page";
import { ServiceSharingPage } from "../pages/service-sharing.page";
import { BookingPartnersPage } from "../pages/booking-partners.page";
import { TemporaryChangesPage } from "../pages/temporary-changes.page";
import { VehicleManagementPage } from "../pages/vehicle-management.page";
import { BusesPage } from "../pages/admin/buses.page";
import { OtaSearchPage } from "../pages/ota-search.page";
import { CancellationPolicyPage } from "../pages/admin/cancellation-policy.page";
import { ExpenseReport } from "../pages/reports/expense.report";
import { StopAnalysisReport } from "../pages/reports/stop-analysis.report";
import { TripsPage } from "../pages/trips.page";
import { EasyTripsPage } from "../pages/easy-trips.page";
import { CoachTypesPage } from "../pages/admin/metadata/coach-types.page";
import { ThemeColorsPage } from "../pages/admin/metadata/theme-colors.page";
import { RedbusCitiesPage } from "../pages/admin/redbus-cities.page";
import { TicketImportPage } from "../pages/admin/ticket-import.page";
import { BulkTripVehicleUpdatePage } from "../pages/admin/bulk-trip-vehicle-update.page";
const DrawLine =({className})=>{
    return(
        <div className={className}>

        </div>
    )
}


export const SchedulePageComponent=(props)=>{
    const {
        location
    } = props;
    if(checkToViewSchedulesPageOfAdmin()){
        return<div className="schedule-page-root">
                    <Helmet>
                            <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
                    </Helmet>
                    <Row>
                        <h3 role="schedule-heading">
                            Schedule
                        </h3>            
                    </Row>
                    <DrawLine className="schedule-underline"/>
                    <SchedulePage
                        selectedScheduleId = {isValid(location)&&isValid(location.state)&&isValid(location.state.selectedScheduleId)?location.state.selectedScheduleId:null}
                    />
            </div>
    }else{
        return null
    }
}

export const VehicleManagementPageComponent=()=>{
    if(checkToViewVechicleManagementPageAdmin()){
        return<div className="vehicle-management-page-root">
            <VehicleManagementPage />
        </div>
    }else{
        return null
    }
}
export const PopularRoutesPageComponent=()=>{
    if(checkToViewPopularRoutesPageAdmin()){
        return<div className="popular-routes-page-root">
                    <Helmet>
                            <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
                    </Helmet>
                    <RoutePriorityPage />
            </div>
    }else{
        return null
    }
}

export const CitiesPageComponent=()=>{
    if(checkToViewCitiesPageAdmin()){
        return<div className="popular-routes-page-root">
                    <Helmet>
                            <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
                    </Helmet>
                    <CitiesPage />
            </div>
    }else{
        return null
    }
}

export const UserActionsPageComponent=()=>{
    if(checkToViewUserActions()){
        return<div className="popular-routes-page-root">
                    <Helmet>
                            <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
                    </Helmet>
                    <Row>
                        <UserActionsPage />
                    </Row>
            </div>
    }else{
        return null
    }
}

export const TicketImportPageComponent=()=>{
    if(checkToViewTicketImportPage()){
        return<div className="ticket-import-page-root">
                    <Helmet>
                            <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
                    </Helmet>
                    <TicketImportPage />
            </div>
    }else{
        return null
    }
}

export const ServiceAccessPageComponent=()=>{
    if(checkToViewServiceAccessPage()){
        return<div className="popular-routes-page-root">
                    <Helmet>
                            <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
                    </Helmet>
                    <ServiceAccessPage />
            </div>
    }else{
        return null
    }
}

export const ServiceSharingPageComponent=()=>{
    if(checkToViewServiceSharingPage()){
        return<div className="popular-routes-page-root">
                    <Helmet>
                            <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
                    </Helmet>
                    <ServiceSharingPage />
            </div>
    }else{
        return null
    }
}

export const BookingPartnersPageComponent=()=>{
    if(checkToViewBookingPartnersPage()){
        return<div className="popular-routes-page-root">
                    <Helmet>
                            <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
                    </Helmet>
                    <BookingPartnersPage />
            </div>
    }else{
        return null
    }
}


const TotalTransactionReportComponent=()=>{
    if(viewTotalTransactionReport()){
        return<div className="report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                            Total Transactions Report
                        </h3>            
                    </Row>
                    <TotalTransactionReport />
            </div>
    }else{
        return null
    }
}

const PerformanceReportComponent=()=>{
    if(viewPerformanceReport()){
        return<div className="report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                            Performance Report
                        </h3>            
                    </Row>
                    <PerformanceReport />
            </div>
    }else{
        return null
    }
}

const RevenueComponent=()=>{
    if(viewRevenueReport()){
        return<div className="report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                            Expected Revenue sheet
                        </h3>            
                    </Row>
                    <RevenueReport />
            </div>
    }else{
        return null
    }
}

const PrePaidTransactionSummary=()=>{
    if(viewPrePaidReport()){
        return<div className="report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                            Prepaid Transactions
                        </h3>            
                    </Row>
                    <PrePaidTransactionsSummary />
            </div>
    }else{
        return null
    }
}

const MasterTripSheetReportComponent=()=>{
    if(viewMasterTripReport()){
        return<div className="report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                            Master trip sheet
                        </h3>            
                    </Row>
                    <MasterTripSheetReport />
            </div>
    }else{
        return null
    }
}

const TicketSearchReportComponent=()=>{
    if(viewTicketSearchReportOld()){
        return<div className="report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                            Ticket search
                        </h3>            
                    </Row>
                    <TicketSearchReport />
            </div>
    }else{
        return null
    }
}

const TicketSearchReportV2Component=()=>{
    if(viewTicketSearchReport()){
        return<div className="ticket-search-report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <TicketSearchReportV2 />
            </div>
    }else{
        return null
    }
}

const RescheduledTicketReportComponent=() => {
    if(viewRescheduledTicketReport()){
        return<div className="report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <Tooltip placement="topRight" title = "This report is based on booking date of initial ticket.">
                            <h3>
                                Rescheduled Ticket
                            </h3>
                        </Tooltip>
                    </Row>
                    <RescheduledTicketReport />
            </div>
    }else{
        return null
    }
}

const ViewPassengersInfoReportComponent=()=>{
    if(viewPassengerInfoReport()){
        return<div className="report-root-with-out-width">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                            Frequent Travellers Report
                        </h3>            
                    </Row>
                    <ViewPassengersInfoReport />
              </div>
    }else{
        return null
    }
}

const TripSheetReportComponent=()=>{
    if(viewTripReport()){
        return<div className="report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                            Trip sheet
                        </h3>            
                    </Row>
                    <TripSheetReport />
              </div>
    }else{
        return null
    }
}


const BookedTicketPageComponent=()=>{
    if(viewBookedTicketsReport()){
        return<div className="report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                           Booked Tickets 
                        </h3>            
                    </Row>
                    <BookedTicketsReport />
            </div>
    }else{
        return null
    }
}

const TicketSharingPageComponent=()=>{
    if(viewTicketSharingReport()){
        return<div className="report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                           Seat sharing 
                        </h3>            
                    </Row>
                    <TicketSharingReport />
            </div>
    }else{
        return null
    }
}

const SettlementPageComponent=()=>{
    if(viewSettlementReport()){
        return<div className="report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                           Settlement Report 
                        </h3>            
                    </Row>
                    <SettlementReport />
            </div>
    }else{
        return null
    }
}

const GstFilingPageComponent=()=>{
    if(viewSettlementReport()){
        return<div className="report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                           GST Filing Report 
                        </h3>            
                    </Row>
                    <GstFilingReport />
            </div>
    }else{
        return null
    }
}

const SalesTicketPageComponent=()=>{
    if(viewSalesReport()){
        return<div className="report-root sales-report">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                            Sales report
                        </h3>
                    </Row>
                    <SalesTicketReport />
            </div>
    }else{
        return null
    }
}

const SharedTripSalesPageComponent=()=>{
    if(viewSharedTripSalesReport()){
        return<div className="report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <SharedTripSalesReport />
            </div>
    }else{
        return null
    }
}

const MasterAgentSalesReportPageComponent=()=>{
    if(viewMasterAgentSalesReport()){
        return<div className="report-root sales-report">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                            Master Agent Sales Report
                        </h3>
                    </Row>
                    <MasterAgentSalesReport />
            </div>
    }else{
        return null
    }
}

const ExpenseReportComponent=()=>{

    if(viewExpenseReport()){
        return<div className="report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                            Expense report
                        </h3>
                    </Row>
                    <ExpenseReport />
            </div>
    }else{
        return null
    }
}

const StopAnalysisReportComponent=()=>{
    if(viewStopAnalysisReport()){
        return<div className="report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                            Stops Analysis
                        </h3>
                        <DrawLine className="stops-analysis-underline"/>
                    </Row>
                    <StopAnalysisReport />
            </div>
    }else{
        return null
    }
}

const BlockedSeatsReportComponent=()=>{
    if(blockedSeatsReport()){
        return<div className="report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                            Blocked Seats
                        </h3>            
                    </Row>
                    <BlockedSeatsReport />
            </div>
    }else{
        return null
    }
}

const CancelledSeatsReportComponent=()=>{
    if(cancelledSeatsReport()){
        return<div className="report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                            Cancelled Seats
                        </h3>            
                    </Row>
                    <CancelledTicketsReport />
            </div>
    }else{
        return null
    }
}

const HomePageComponent=()=>{
    if(checkSearchPage()){
        return<div>
                    <Helmet>
                            <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
                    </Helmet>
                    <HomePage />
            </div>
    }else{
        return null
    }
}

const EditTripComponent=()=>{
    return(
        <ManualTripPage />
    )
}
const AddressBookComponent=()=>{
    return(
        <AddressBookPage />
    )
}

const TripsPageComponent = () => {
    if (checkToViewTripsPageOfAdmin){
        return (
            <TripsPage />
        )
    }
    else {
        return null;
    }
}

const EasyTripPageComponent = () => {
    if (checkToViewTripsPageOfAdmin) {
        return (
            <EasyTripsPage />
        )
    }
    else {
        return null;
    }
}

const BulkTripVehicleUpdatePageComponent = () => {
    if (checkToViewBulkTripVehicleUpdatePage()) {
        return (
            <div>
                <Helmet>
                    <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
                </Helmet>
                <BulkTripVehicleUpdatePage />
            </div>
        )
    }
    else {
        return null;
    }
}

const DashboardPageComponent=()=>{
    if(checkDashBoardPage()){
        return<div>
                    <Helmet>
                            <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
                    </Helmet>
                    <DashboardPage />
            </div>
    }else{
        return null
    }
}

const LoginPageComponent=()=>{
    return<div>
                <Helmet>
                        <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
                </Helmet>
                <LoginPage />
          </div>
}

const RazorpayAuthorizePageComponent=()=>{
    return<div>
                <Helmet>
                        <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
                </Helmet>
                <RazorpayAuthorizePage />
          </div>
}


const BusCancelPageComponent=()=>{
    if(checkBusCancellationPage()){
        return<div>
                    <Helmet>
                            <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
                    </Helmet>
                    <BusCancelPage />
            </div>
    }else{
        return null
    }
}

const StaffPageComponent=()=>{
    if(checkStaffPage()){
        return<div>
                    <Helmet>
                            <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
                    </Helmet>
                    <StaffPage />
            </div>
    }else{
        return null
    }
}

const AgentsPageComponent=()=>{
    if(checkAgentsPage()){
        return<div>
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <AgentsPage />
            </div>
    }else{
        return null
    }
}

const AgentTransactionsPageComponent=()=>{
    if(checkAgentsTransactionPage()){
        return<div>
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <AgentTransactonsPage />
            </div>
    }else{
        return null
    }
}

const AgentLedgerPageComponent=()=>{
    if(checkAgentLedgerPage()){
        return<div>
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <AgentLedgerPage />
            </div>  
    }else{
        return null
    }
}

const SystemInfoPageComponent=()=>{
    if(checkToViewSystemInfoPage()){
        return<div>
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <SystemInfoPage />
            </div>
    }else{
        return null
    }
}

const TripCreatePageComponent = () => {
    if(tripCreate()){
        return<div>
                   <Helmet>
                            <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
                   </Helmet>
                   <TripCreatePage />
        </div>
    }else{
        return null
    }
}

const IncompleteTripPageComponent = () =>{
    if(checkToViewTripsPageOfAdmin()){
        return(
            <div>
                 <Helmet>
                        <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
                </Helmet>
                <IncompleteTripPage />
            </div>
        )
    }else{  
        return null;
    }
}

const StandardStopsComponent = () =>{
    if(checkToViewStandardStopsPage()){
        return(
            <div>
                 <Helmet>
                        <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
                </Helmet>
                <StandardStopsPage />
            </div>
        )
    }else{  
        return null;
    }
}

const CreateStandardStopComponent = () =>{
    if(checkToViewStandardStopsPage()){
        return(
            <div>
                 <Helmet>
                        <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
                </Helmet>
                <CreateStandardStopsPage />
            </div>
        )
    }else{  
        return null;
    }
}


const ViewTicketPageComponent=()=>{
    if(checkCancelPage()){
        return<div>
                    <Helmet>
                            <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
                    </Helmet>
                    <ViewTicketPage />
            </div>
    }else{
        return null
    }
}

const ChangePasswordPageComponent=()=>{
        return<div>
                    <Helmet>
                            <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
                    </Helmet>
                    <ChangePasswordPage />
            </div>
}

const ViewAbandonedComponent=()=>{
    if(checkViewAbandonedReport()){
        return(<div className="report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                            Abandoned sheet
                        </h3>            
                    </Row>
                    <AbandonedReport />
            </div>)
    }else{
        return null
    }
}

const WebTicketSalesComponent=()=>{
    if(checkWebTicketSalesReport()){
        return(<div className="report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                            Web ticket sales sheet
                        </h3>            
                    </Row>
                    <WebSalesTicketReport />
            </div>)
    }else{
        return null
    }
}

const WebTicketCancelComponent=()=>{
    if(checkWebTicketCancelReport()){
        return(<div className="report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                            Web ticket cancel sheet
                        </h3>            
                    </Row>
                    <WebTicketCancelReport />
            </div>)
    }else{
        return null
    }
}

const TripSheetPermissionComponent=()=>{
    if(checkToViewTripSheetPermissionPage()){
        return(<div className="report-root">
                    <Row>
                        <h3>
                            Trip Sheet Permissions
                        </h3>            
                    </Row>
                    <DrawLine className="trip-sheet-permissions-underline"/>
                    <TripSheetPermissionPage />
            </div>)
    }else{
        return null
    }
}


const TicketsBookedAfterTripStartTimeComponent=()=>{
    if(viewTicketBookedAfterTripStartTime()){
        return(<div className="report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                            Tickets Booked After Departure
                        </h3>            
                    </Row>
                    <TicketsBookedAfterTripStartTime />
            </div>)
    }else{
        return null
    }
}


const SmsReport=()=>{
    if(viewSmsReport()){
        return(<div className="report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                            SMS Report
                        </h3>            
                    </Row>
                    <SmsReportComponent />
            </div>)
    }else{
        return null
    }
}

const DemandDataReportComponent = () => {
    if (viewDemandDataReport()){
        return(<div className="report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                            Demand Data report
                        </h3>
                    </Row>
                    <DemandDataReport />
        </div>)
    }else {
        return null;
    }
}

const ActiveBookingsReportComponent=()=>{
    if(viewActiveBookings()){
        return<div className="report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                            Live Bookings
                        </h3>            
                    </Row>
                    <ActiveBookingsReport />
            </div>
    }else{
        return null
    }
}

const ServiceCountReportComponent=()=>{
    if(viewServiceCountReport()){
        return<div className="report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                            Service count
                        </h3>            
                    </Row>
                    <ServiceCountReport />
            </div>
    }else{
        return null
    }
}

const OccupancyReportComponent=()=>{
    if(viewOccupancyReport()){
        return<div className="report-root-with-out-width occupancy-report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <OccupancyReport />
            </div>
    }else{
        return null
    }
}

const BusServiceCollectionReportComponent=()=>{
    if(viewBusServiceCollectionReport()){
        return<div className="report-root-with-out-width bus-service-collection-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <BusServiceCollectionReport />
            </div>
    }else{
        return null
    }
}

const CostSummaryReportComponent=()=>{
    if(viewCostSummaryReportReport()){
        return<div className="report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                            Billing Report
                        </h3>
                    </Row>
                    <CostSummaryReport />
            </div>
    }else{
        return null
    }
}

const TransactionSummaryReportComponent=()=>{
    if(viewTransactionSummaryReportReport()){
        return<div className="report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                            Transaction Summary Report
                        </h3>
                    </Row>
                    <TransactionSummaryReport />
            </div>
    }else{
        return null
    }
}

const TrackingSummaryReportComponent=()=>{
    if(viewTrackingSummaryReport()){
        return<div className="report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                            Tracking Summary Report
                        </h3>
                    </Row>
                    <TrackingSummaryReport />
            </div>
    }else{
        return null
    }
}

const DriverAttendanceReportComponent=()=>{
    if(viewDriverAttendanceReport()){
        return<div className="report-root">
                    <Helmet>
                        <meta name="viewport" content="initial-scale=.5, maximum-scale=12.0, minimum-scale=.25, user-scalable=yes"/>
                    </Helmet>
                    <Row>
                        <h3>
                            Driver Attendance
                        </h3>
                        <DrawLine className="driver-attendance-underline"/>
                    </Row>
                    <DriverAttendanceReport />
            </div>
    }else{
        return null
    }
}

const PrepaidOTAPageComponent=()=>{
    if(checkPrepaidOTAPage()){
        return<div>
                    <Helmet>
                            <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
                    </Helmet>
                    <PrepaidOTAPage />
            </div>
    }else{
        return null
    }
}

const OperatorConfigPageComponent = ()=>{
    if(checkToViewOperatorConfig()){
        return(
            <div>
                <OperatorConfigPage />
            </div>
        )
    }else{
        return null;
    }
}

const QbccConfigPageComponent = ()=>{
    if(checkToViewOperatorConfig()){
        return(
            <div>
                <QbccConfigPage />
            </div>
        )
    }else{
        return null;
    }
}


const BusOperatorPageComponent = ()=>{
    if(checkToViewBusOperatorPage()){
        return(
            <div>
                <BusOperatorPage />
            </div>
        )
    }else{
        return null;
    }
}


const SettlementsRootPageComponent = () => {
    // Any of the sub-permissions grants page access; tabs filter inside
    if (viewSettlementAdmin() || checkToGenerateSettlementDraft() || checkToSetSettlementOpeningBalance()) {
        return (
            <div>
                <SettlementsRootPage />
            </div>
        );
    }
    return null;
}

const SettlementsBillingPageComponent = () => {
    if (viewOwnSettlement()) {
        return (
            <div>
                <SettlementsBillingPage />
            </div>
        );
    }
    return null;
}

const BookingConfigPageComponent = () => {
    if (checkToViewBookingConfig()) {
        return (
            <div>
                <BookingConfigPage />
            </div>
        );
    } else {
        return null;
    }
}

const DiscountConfigPageComponent = () => {
    if (checkToViewDiscountConfig()) {
        return (
            <div>
                <DiscountConfigPage />
            </div>
        );
    } else {
        return null;
    }
}

const BillingConfigPageComponent = () => {
    if (checkToViewBillingConfig()) {
        return (
            <div>
                <BillingConfigPage />
            </div>
        );
    } else {
        return null;
    }
}

const ColourConfigPageComponent = () => {
    if (checkToViewColourConfig()) {
        return (
            <div>
                <ColourConfigPage />
            </div>
        )
    } else {
        return null;
    }
}

const OperatorWebsitePageConfigComponent = () => {
    if (checkToViewOperatorWebsiteConfig()) {
        return (
            <div className="operator-website-page-config-root">
                <OperatorWebsitePageConfig />
            </div>
        );
    } else {
        return null;
    }
}

const ExpenseConfigPageComponent = () => {
    if (checkToViewExpenseConfig()) {
        return (
            <div>
                <ExpenseConfigPage />
            </div>
        )
    } else {
        return null;
    }
}

export const TemporaryChangesPageComponent = () => {
    if(checkToViewTemporaryChangesPage()){
        return <div className="temporary-changes-page-root">
                    <Helmet>
                        <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
                    </Helmet>
                    <TemporaryChangesPage />
            </div>
    } else {
        return null
    }
}

const AgentsUserPageComponent = () => {
    if(checkToViewAgentsPageOfAdmin()){
        return <div>
            <AgentsUserPage />
        </div>
    }
}

const BusesPageComponent = () => {
    if(checkToViewBusesPageAdmin()){
        return <div className="buses-page-root">
                    <Helmet>
                        <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
                    </Helmet>
                    <BusesPage />
            </div>
    } else {
        return null
    }
}

const OtaSearchPageComponent = () => {
    if(checkToViewOtaSearchPage()){
        return <div className="buses-page-root">
                    <Helmet>
                        <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
                    </Helmet>
                    <OtaSearchPage />
            </div>
    } else {
        return null
    }
}

const CancellationPolicyPageComponent = () => {
    if(checkToViewCancellationPolicyPage()){
        return <div className="buses-page-root">
                    <Helmet>
                        <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
                    </Helmet>
                    <CancellationPolicyPage />
            </div>
    } else {
        return null
    }
}


export const RouteRoot = () => {

    var isLoggedIn = useSelector(userLoginSelector);

    return (
        <Router>
            <DeviceProvider>
                {isLoggedIn&&
                    <AppHeader />
                }
                <LoadingComponent />
                <Switch>
                    <Route path="/login" component={LoginPageComponent} />
                    <Route path="/razorpay-authorize" component={RazorpayAuthorizePageComponent} />
                    <PrivateRoute path="/accounts/agent-transactions" component={AgentTransactionsPageComponent} />
                    <PrivateRoute path="/accounts/agent-ledger" component={AgentLedgerPageComponent} />
                    <PrivateRoute path="/system-info" component={SystemInfoPageComponent} />
                    <PrivateRoute path="/trip-create/success" component={TripCreateSuccessPage} />
                    <PrivateRoute path="/accounts/agents" component={AgentsPageComponent} />
                    <PrivateRoute path="/staff" component={StaffPageComponent} />
                    <PrivateRoute path="/trip-create" component={TripCreatePageComponent} />
                    <PrivateRoute path="/new-trip" component={IncompleteTripPageComponent} />
                    <PrivateRoute path="/standard-stops" component={StandardStopsComponent} />
                    <PrivateRoute path="/create-standard-stop" component={CreateStandardStopComponent} />
                    <PrivateRoute path="/view-cancel" component={ViewTicketPageComponent} />
                    <PrivateRoute path="/view-ticket-search" component={TicketSearchReportV2Component} />
                    <PrivateRoute path="/change-password" component={ChangePasswordPageComponent} />
                    <PrivateRoute path="/report/tripsheet" component={TripSheetReportComponent} />
                    <PrivateRoute path="/report/bookedtickets" component={BookedTicketPageComponent} />
                    <PrivateRoute path="/report/ticketsharingreport" component={TicketSharingPageComponent} />
                    <PrivateRoute path="/report/settlementreport" component={SettlementPageComponent} />      
                    <PrivateRoute path="/report/gstfilingreport" component={GstFilingPageComponent} />                              
                    <PrivateRoute path="/report/salesreport" component={SalesTicketPageComponent} />
                    <PrivateRoute path="/report/sharedtripsales" component={SharedTripSalesPageComponent} />
                    <PrivateRoute path="/report/masteragentsalesreport" component={MasterAgentSalesReportPageComponent} />
                    <PrivateRoute path="/report/expense-report" component={ExpenseReportComponent} />
                    <PrivateRoute path="/report/stop-analysis" component={StopAnalysisReportComponent} />
                    <PrivateRoute path="/report/viewActiveBookings" component={ActiveBookingsReportComponent} />
                    <PrivateRoute path="/report/viewServiceCountReport" component={ServiceCountReportComponent} />
                    <PrivateRoute path="/report/occupancyReport" component={OccupancyReportComponent} />
                    <PrivateRoute path="/report/busservicecollection" component={BusServiceCollectionReportComponent} />
                    <PrivateRoute path="/report/costSummaryReport" component={CostSummaryReportComponent} />
                    <PrivateRoute path="/report/transactionSummaryReport" component={TransactionSummaryReportComponent} />
                    <PrivateRoute path="/report/trackingSummaryReport" component={TrackingSummaryReportComponent} />
                    <PrivateRoute path="/report/driverAttendanceReport" component={DriverAttendanceReportComponent} />
                    <PrivateRoute path="/report/mastertripsheetreport" component={MasterTripSheetReportComponent} />
                    <PrivateRoute path="/report/ticketsearchreport" component={TicketSearchReportComponent} />
                    <PrivateRoute path="/report/rescheduledTicketreport" component={RescheduledTicketReportComponent} />
                    <PrivateRoute path="/report/viewpassengersreport" component={ViewPassengersInfoReportComponent} />
                    <PrivateRoute path="/report/blockedreport" component={BlockedSeatsReportComponent} />
                    <PrivateRoute path="/report/totaltransactionreport" component={TotalTransactionReportComponent} />
                    <PrivateRoute path="/report/cancelledticketreport" component={CancelledSeatsReportComponent} />
                    <PrivateRoute path="/report/performancereport" component={PerformanceReportComponent} />
                    <PrivateRoute path="/report/revenuereport" component={RevenueComponent} />
                    <PrivateRoute path="/report/abandonedreport" component={ViewAbandonedComponent} />
                    <PrivateRoute path="/report/webticketsalesreport" component={WebTicketSalesComponent} />
                    <PrivateRoute path="/report/webticketcancelreport" component={WebTicketCancelComponent} />
                    <PrivateRoute path="/report/prepaidtransactions" component={PrePaidTransactionSummary} />

                    <PrivateRoute path="/accounts/trip-sheet-permission" component={TripSheetPermissionComponent} />
                    <PrivateRoute path="/report/smsreport" component={SmsReport} />
                    <PrivateRoute path="/report/ticketbookedafterdeparture" component={TicketsBookedAfterTripStartTimeComponent} />
                    <PrivateRoute path="/report/demandDataReport" component={DemandDataReportComponent} />
                    <PrivateRoute path="/admin/schedule" component={SchedulePageComponent} />
                    <PrivateRoute path="/admin/popular-routes" component={PopularRoutesPageComponent} />
                    <PrivateRoute path="/admin/cities" component={CitiesPageComponent} />
                    <PrivateRoute path="/admin/user-actions" component={UserActionsPageComponent} />
                    <PrivateRoute path="/admin/vehicle-management" component={VehicleManagementPageComponent} />
                    <PrivateRoute path="/admin/users" component={AgentsUserPageComponent} />

                    <PrivateRoute path="/users/service-access" component={ServiceAccessPageComponent} />
                    <PrivateRoute path="/users/service-sharing" component={ServiceSharingPageComponent} />
                    <PrivateRoute path="/users/booking-partners" component={BookingPartnersPageComponent} />
                    <PrivateRoute path="/home" component={HomePageComponent} />
                    <PrivateRoute path="/prepaid-ota" component={PrepaidOTAPageComponent} />
                    <PrivateRoute path="/dashboard" component={DashboardPageComponent} />
                    <PrivateRoute path="/ota-search" component={OtaSearchPageComponent} />
                    <PrivateRoute path="/edittrip" component={EditTripComponent} />
                    <PrivateRoute path="/admin/addressbook" component={AddressBookComponent} />
                    <PrivateRoute path ="/admin/trips" component={TripsPageComponent} />
                    <PrivateRoute path="/admin/bulk-trip-vehicle-update" component={BulkTripVehicleUpdatePageComponent} />
                    <PrivateRoute path="/easytrip" component = {EasyTripPageComponent} />
                    <PrivateRoute path="/admin/operatorconfig" component={OperatorConfigPageComponent} />
                    <PrivateRoute path="/admin/qbcc-config" component={QbccConfigPageComponent} />
                    <PrivateRoute path="/admin/bus-operator" component={BusOperatorPageComponent} />
                    <PrivateRoute path="/settlements" component={SettlementsRootPageComponent} />
                    <PrivateRoute path="/settlement-billing" component={SettlementsBillingPageComponent} />
                    <PrivateRoute path="/admin/booking-config" component={BookingConfigPageComponent} />
                    <PrivateRoute path="/admin/billing-config" component={BillingConfigPageComponent} />
                    <PrivateRoute path="/admin/discount-config" component={DiscountConfigPageComponent} />
                    <PrivateRoute path="/admin/colourconfig" component={ColourConfigPageComponent} />
                    <PrivateRoute path="/admin/operator-website-config" component={OperatorWebsitePageConfigComponent} />
                    <PrivateRoute path="/admin/expenseconfig" component={ExpenseConfigPageComponent} />
                    <PrivateRoute path="/admin/temporary-changes" component={TemporaryChangesPageComponent} />
                    <PrivateRoute path="/admin/buses" component={BusesPageComponent} />
                    <PrivateRoute path="/admin/cancellation-policy" component={CancellationPolicyPageComponent} />
                    <PrivateRoute path="/admin/metadata/coach-types" component={CoachTypesPage} />
                    <PrivateRoute path="/admin/metadata/theme-colors" component={ThemeColorsPage} />
                    <PrivateRoute path="/admin/redbus-cities" component={RedbusCitiesPage} />
                    <PrivateRoute path="/admin/ticket-import" component={TicketImportPageComponent} />
                    <PrivateRoute path="/" component={HomePageComponent} />
                </Switch>
            </DeviceProvider>
        </Router>
    );
} 